/* Velurya · completa las tablas de Kiwi Size Chart que se pintan en la ficha con las tallas que les faltan (hasta 3XL).
   No cambia Kiwi: solo añade filas en esta página, a partir de VF.FULL (velurya-talla-datos.js). */
(function(){
  if (window.__vk3 || !window.VF || !VF.FULL) return; window.__vk3 = 1;
  function n(s){ return String(s == null ? '' : s).replace(/\s+/g, '').replace(/,/g, '.').toUpperCase(); }
  var ALL = [];
  for (var k in VF.FULL) VF.FULL[k].forEach(function(t){ ALL.push(t.rows); });
  function rowsOf(t){
    return [].slice.call(t.rows).map(function(r){ return [].slice.call(r.cells).map(function(c){ return c.textContent; }); });
  }
  function match(rows){
    var data = rows.slice(1).filter(function(r){ return r.length > 1; });
    if (!data.length) return null;
    for (var i = 0; i < ALL.length; i++) {
      var F = ALL[i], ok = F[0].length === rows[0].length;
      for (var j = 0; ok && j < data.length; j++) {
        var hit = false;
        for (var q = 1; q < F.length && !hit; q++) hit = F[q].map(n).join('|') === data[j].map(n).join('|');
        ok = hit;
      }
      if (ok) return F;
    }
    return null;
  }
  function patch(t){
    if (t.__vk3) return; t.__vk3 = 1;
    var rows = rowsOf(t), F = match(rows); if (!F) return;
    var have = {}; rows.forEach(function(r){ have[n(r[0])] = 1; });
    var body = t.tBodies[0] || t, tpl = t.rows[t.rows.length - 1];
    F.slice(1).forEach(function(r){
      if (have[n(r[0])]) return;
      var tr = tpl.cloneNode(true), cells = tr.cells;
      for (var c = 0; c < cells.length && c < r.length; c++) cells[c].textContent = r[c];
      tr.setAttribute('data-velurya', 'nueva');
      body.appendChild(tr);
    });
  }
  // Prendas sin tabla en Kiwi (jerséis hombre, cárdigan, pantalones de talla numérica…): tabla oculta con nuestras medidas
  // para que la guía de tallas la muestre completa. Si luego Kiwi pinta la suya, se quita.
  var root = document.querySelector('.vfit[data-key]'), KEY = root && root.dataset.key, own = null;
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function inject(){
    if (own || !KEY || !VF.FULL[KEY] || document.querySelector('table.ks-table:not([data-velurya])')) return;
    own = document.createElement('div'); own.hidden = true; own.setAttribute('aria-hidden', 'true');
    own.innerHTML = VF.FULL[KEY].map(function(t){
      return '<table class="ks-table" data-velurya="propia">' + t.rows.map(function(r, i){
        return '<tr>' + r.map(function(c, j){ return i === 0 || j === 0 ? '<th>' + esc(c) + '</th>' : '<td>' + esc(c) + '</td>'; }).join('') + '</tr>';
      }).join('') + '</table>';
    }).join('');
    document.body.appendChild(own);
  }
  setTimeout(inject, 2500);
  function run(){
    if (own && document.querySelector('table.ks-table:not([data-velurya])')) { own.remove(); own = null; }
    document.querySelectorAll('table.ks-table:not([data-velurya])').forEach(patch);
  }
  var tm = 0;
  run();
  new MutationObserver(function(){ if (!tm) tm = setTimeout(function(){ tm = 0; run(); }, 120); }).observe(document.body, { childList: true, subtree: true });
})();